<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.videoUrl && _vm.documentType === "video"
      ? _c(
          "video",
          {
            staticClass: "upload-img-pick",
            attrs: { controls: "" },
            on: { loadeddata: _vm.handleVideoLoad, error: _vm.handleVideoLoad },
          },
          [
            _c("source", { attrs: { src: _vm.videoUrl, type: "video/webm" } }),
            _c("source", { attrs: { src: _vm.videoUrl, type: "video/ogg" } }),
            _c("source", { attrs: { src: _vm.videoUrl, type: "video/mp4" } }),
            _c("source", { attrs: { src: _vm.videoUrl, type: "video/mkv" } }),
            _c("source", { attrs: { src: _vm.videoUrl, type: "video/avi" } }),
            _c("source", {
              attrs: { src: _vm.videoUrl, type: "video/vnd.rn-realvideo" },
            }),
            _c("source", {
              attrs: { src: _vm.videoUrl, type: "video/x-msvideo" },
            }),
            _c("source", {
              attrs: { src: _vm.videoUrl, type: "video/vnd.rn-realvideo" },
            }),
            _c("source", {
              attrs: { src: _vm.videoUrl, type: "video/quicktime" },
            }),
            _c("source", {
              attrs: { src: _vm.videoUrl, type: "video/x-ms-wmv" },
            }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "Dispute-Status-pop.YourBrowserDoesNotSupportTheVideoTag."
                  )
                ) +
                " "
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/VideoPreview.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import * as vuex from 'vuex';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default ({
  render,
  staticRenderFns,
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"],
    BImg: bootstrapvue["BImg"]
  },
  data() {
    return {
      showImage: true
    };
  },
  computed: {
    ...vuex.mapState("user", ["isLoadingArray"])
  },
  watch: {
    videoUrl(newVal) {
      if (newVal) {
        this.showImage = true;
      } else {
        this.showImage = false;
      }
    }
  },
  methods: {
    ...vuex.mapMutations("user", ["setLoadingArray"]),
    handleVideoLoad() {
      if (this.isLoading) {
        this.isLoadingArray.pop();
        this.setLoadingArray(this.isLoadingArray);
      } else {
        this.showImage = false;
      }
    }
  },
  props: {
    videoUrl: {
      type: String,
      default: ""
    },
    documentType: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/VideoPreview.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.upload-img-pick {
  width: 100%;
  max-width: none;
}
</style>
